<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-card :loading="loading">
              <v-card-title class="pb-5">
                <!--                                    v-if="$can('transaction_create')"-->
                <!--                <v-btn @click="$router.push({path: '/permission'})" class="btn-back">-->
                <!--                  <span class="flaticon2-reply icon-lg"></span>-->
                <!--                  بازگشت-->
                <!--                </v-btn>-->
                <!--                <v-spacer/>-->
                <!--                {{ $t($route.meta.title) }}-->
                <!--                <v-spacer/>-->
                <v-btn @click="addPack" class="submit-btn" :loading="loading">
                  <span class="fa fa-bookmark icon-md ml-1"></span>
                  ذخیره
                </v-btn>
              </v-card-title>

              <v-card-text>
                <v-row class="mt-8">
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2" v-if="hasSql">
                    <div class="row form-inline">
                      <v-textarea
                        append-icon="mdi-database"
                        id="mysql"
                        outlined
                        label="کد SQL برای سهولت اجرا در سرور(به ادمین تحویل دهید.)"
                        v-model="text"
                      ></v-textarea>

                      <button
                        type="button"
                        class="btn btn-copy text-success font-weight-bold"
                        @click="copyText()"
                      >
                        <v-icon v-if="copied" color="green">کپی شد</v-icon>
                        <span v-else>کپی کردن</span>
                      </button>
                    </div>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <label for="residenceProvince">انتخاب دسته بندی</label>
                    <v-overflow-btn
                      append-icon="mdi-menu"
                      id="residenceProvince"
                      editable
                      auto-select-first
                      outlined
                      v-model="category_id"
                      :items="categories"
                    />
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <v-card elevation="0" color="transparent" class="mb-4">
                      <v-card
                        v-for="(x, i) in value"
                        :key="i"
                        outlined
                        class="mb-4"
                      >
                        <v-card-title>
                          <v-chip outlined color="#009688">
                            پرمیشن {{ i + 1 }}
                          </v-chip>

                          <v-spacer />
                          <v-btn
                            x-small
                            fab
                            elevation="0"
                            color="error"
                            @click="deleteKeyValue(x, i)"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </v-card-title>

                        <v-row align="center" class="ma-0 pt-3">
                          <v-col cols="6" lg="6" class="pt-0">
                            <v-text-field
                              label="نام لاتین"
                              v-model="x.name"
                              outlined
                              id="propKey"
                            />
                          </v-col>
                          <v-col cols="6" lg="6" class="pt-0">
                            <v-text-field
                              label="نام فارسی"
                              v-model="x.name_fa"
                              outlined
                              id="propValue"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-content-center mt-1">
                          <v-label>سطح دسترسی :</v-label>
                        </v-row>
                        <v-row class="flex-column align-items-center">
                          <v-radio-group row v-model="x.privilege_type">
                            <v-radio
                              label="ادمین"
                              color="primary"
                              value="admin"
                            ></v-radio>
                            <v-radio
                              label="کاربر"
                              color="primary"
                              value="user"
                            ></v-radio>
                          </v-radio-group>
                        </v-row>
                      </v-card>

                      <v-card-actions class="pa-0 my-4">
                        <v-btn block color="accent" @click="newKeyValue">
                          <v-icon>mdi-plus</v-icon>
                          افزودن پرمیشن جدید
                        </v-btn>
                      </v-card-actions>

                      <v-divider />
                    </v-card>
                  </v-flex>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { SET_BREADCRUMB } from "../../../core/services/store/breadcrumbs.module";
import smsTariffPicker from "@/view/pages/pickers/smsTariffPicker";
import priceInput from "@/view/pages/pickers/priceInput";
import subLinePicker from "@/view/pages/pickers/subLinePicker";
import permissionPicker from "@/view/pages/pickers/permissionPicker";

export default {
  components: { smsTariffPicker, priceInput, subLinePicker, permissionPicker },
  data() {
    return {
      service: [],
      services: [],
      copied: false,
      text: null,
      loading: false,
      value: [],
      hasSql: null,
      categories: [],
      category_id: null,
      title: null,
      title_fa: "",
      expire: null,
      permissions: {},

      tariff: {},
      subline: {},
      tariffs: [],
      owner: { id: null },
      owners: [
        { id: 1, name: "فعال" },
        { id: 0, name: "غیر فعال" },
      ],
      show: { id: null },
      shows: [
        { id: 1, name: "فعال" },
        { id: 0, name: "غیر فعال" },
      ],
      sortOrder: null,
      features: [],
      description: null,
      role: { id: null },
      roles: [],
      errors: [],
      rules: {
        title: [
          (val) => (val || "").length > 0 || "فیلد عنوان الزامی می باشد.",
        ],
        permissions: [
          (val) => (val || []).length > 0 || "فیلد دسترسی الزامی می باشد.",
        ],
      },
    };
  },

  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
    this.getCategories();
  },

  methods: {
    newKeyValue() {
      if (this.category_id == null) {
        return this.$toast.error(
          "لطفا ابتدا نوع دسته بندی پرمیشن ها را انتخاب کنید."
        );
      }
      this.value.push({
        name: "",
        name_fa: "",
        privilege_type: "",
        category_id: this.category_id,
      });
    },
    deleteKeyValue(x, i) {
      if (confirm("پرمیشن حذف شود ؟")) {
        this.value.splice(this.value.indexOf(i), 1);
      }
    },
    copyText() {
      if (navigator) {
        navigator.clipboard.writeText(this.text);
      }
      this.copied = true;
      let i = setInterval(() => {
        this.copied = false;
        clearInterval(i);
      }, 1000);
    },

    addPack() {
      this.loading = true;
      this.requestApiPost("permission", {
        category_id: this.category_id,
        permission: this.value,
      })
        .then((response) => {
          this.loading = false;
          this.$toast.success("پرمیشن های جدید با موفقیت ساخته شد.");
          this.text = response.data.sql;
          this.hasSql = true;
          // const el = document.getElementById('mysql');
          // el.scrollIntoView({behavior: "smooth"});
        })
        .catch(({ response }) => {
          this.loading = false;
          this.errors = response;
        });
    },

    getCategories() {
      this.loading = true;

      this.requestApiGet("category/get-all", { permission: true })
        .then(({ data }) => {
          let category = [];
          for (let i = 0; i < data.length; i++) {
            category.push({
              text:
                data[i].name + " \t" + "( " + data[i].service.nameLand + " )",
              value: data[i].id,
            });
          }
          this.categories = category;
          this.loading = false;
        })
        .catch(({ response }) =>
          console.log("error in get provinces: ", response)
        );
    },
  },
};
</script>
